import Cookies from "js-cookie";

const GroupAccess = (strgroups) => {
    if(Cookies.get("groups")) {
        const usergroups = JSON.parse(Cookies.get("groups"));
        const grouplist = strgroups.toUpperCase().split("|");

        return usergroups.map((usergroup) => grouplist.includes(usergroup.toUpperCase())).reduce((a, b) => a || b);
    } else {
        return null;
    }
};
export default GroupAccess;
